export default "__VITE_ASSET__d0bf086d__"